enum TransactionProviderType {
  INTERNAL = 'Internal',
  EXTERNAL = 'External',
}

export default TransactionProviderType;
